/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-08 12:49:14
 */
import React from 'react'
import { Typography } from 'antd'
import '../index.scss'

const { Text, Title } = Typography

/**
 * 等待识别组件 - 根据Figma设计稿实现
 */
const RecognitionContentWaiting: React.FC = React.memo(() => {
  return (
    <div className="waiting-recognition">
      {/* 分析结论区域 */}
      <div className="right-section">
        <div className="section-title">
          <Text className="title-text">识别到的隐患</Text>
        </div>
        <div className="right-section-content">
          <Text className="right-section-content-text">待生成识别结果</Text>
        </div>
      </div>

      {/* 相关知识区域 */}
      <div className="right-section">
        <div className="section-title">
          <Text className="title-text">参考标准</Text>
        </div>
        <div className="right-section-content">
          <Text className="right-section-content-text">
            待检索相关国家相关安全法规
          </Text>
        </div>
      </div>

      {/* 思考过程区域 */}
      <div className="right-section">
        <div className="section-title">
          <Text className="title-text">思考过程</Text>
        </div>
        <div className="right-section-content">
          <Text className="right-section-content-text">待分析</Text>
        </div>
      </div>
    </div>
  )
})

export default RecognitionContentWaiting
